import { FaqAccordionItemModel } from '@marketplace-web/user-agreements/privacy-center-data'

const usePrivacyFaqAccordionsContent = () => {
  const privacyFaqAccordionsContent: Array<FaqAccordionItemModel> = [
    {
      title: 'privacy_center.faq_section.delete_data_faq.title',
      description: 'privacy_center.faq_section.delete_data_faq.description',
    },
    {
      title: 'privacy_center.faq_section.change_username_faq.title',
      description: 'privacy_center.faq_section.change_username_faq.description',
    },
    {
      title: 'privacy_center.faq_section.change_data_faq.title',
      description: 'privacy_center.faq_section.change_data_faq.description',
    },
    {
      title: 'privacy_center.faq_section.refuse_data_faq.title',
      description: 'privacy_center.faq_section.refuse_data_faq.description',
    },
    {
      title: 'privacy_center.faq_section.contact_faq.title',
      description: 'privacy_center.faq_section.contact_faq.description',
    },
  ]

  return privacyFaqAccordionsContent
}

export default usePrivacyFaqAccordionsContent
